module.exports = __webpack_public_path__ + "static/media/blbLogoWT-1300.4d48ac31.png";